var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import { useQuery } from '@tanstack/react-query';
import { fetchReportUserDailyDetail, fetchReportUserMonthly } from '../../../cores/api/api-dashboard';
import { LineChart } from '../../components/line-chart';
import React from 'react';
export default function SectionUserReportChart({ gender, params, onChange }) {
    const _useQuery = useQuery({
        queryKey: ['user-sale-chart', params, gender],
        suspense: true,
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            if (params.mode === 'year') {
                const res = yield fetchReportUserMonthly({
                    year: params.year,
                    gender,
                    sort_by: 'month',
                    order: 'asc'
                });
                return res.data;
            }
            if (params.mode === 'month' && params.month) {
                const res = yield fetchReportUserDailyDetail({
                    year: params.year,
                    month: params.month,
                    gender,
                    per_page: 31,
                    sort_by: 'day',
                    order: 'asc'
                });
                return res.daily_data.map(d => _objectSpread(_objectSpread({}, d), {}, {
                    month: params.month
                }));
            }
            return [];
        })
    }), data = _useQuery.data;
    return /*#__PURE__*/ React.createElement(LineChart, {
        items: data !== null && data !== void 0 ? data : [],
        params: params,
        gender: gender,
        viewMode: "chart",
        onChange: onChange
    });
}
